const get_tag = (data) => {
    if (!Number.isNaN(parseFloat(data?.promocao)) && parseFloat(data?.promocao) > 0) return `DE: ${parseFloat(data.valor).toLocaleString('pt-BR', {currency:'BRL', style:'currency'})}`
    if (!Number.isNaN(parseFloat(data?.desconto)) && parseFloat(data?.desconto) > 0) return `- ${parseFloat(data.desconto).toLocaleString('pt-BR', {currency:'BRL', style:'currency'})}`
    if (!Number.isNaN(parseInt(data?.porcdesconto)) && parseInt(data?.porcdesconto) > 0) return `${parseInt(data.porcdesconto)}%`
    return ''
}

export default get_tag